<template>
  <DHLReturnShowBlock
      v-if="loaded"
      :DHLReturn="DHLReturn"
  />
</template>

<script>
  import DHLReturnShowBlock from "./DHLReturnShowBlock/DHLReturnShowBlock.vue";
  import { DHLReturn } from "../../models/DHLReturn";
  import {DHLReturnMixin} from "@/mixins/DHLReturnMixins/DHLReturnMixin";

  export default {
    name: "DHLReturnShow",

    components:{
      DHLReturnShowBlock,
    },

    mixins: [DHLReturnMixin],

    // watch: {
    //   loadUserAuthorizedData() {
    //     this.DHLReturn.data.User.setUser(this.loadUserAuthorizedData.user);
    //   }
    // },

    data() {
      return {
        DHLReturn: new DHLReturn(),
        loaded: false,
      }
    },
    mounted() {

      let orderId = this.$route.params.id

      let dispatchType = 'getReturnParcelsDHL'

      this.$store.dispatch(dispatchType, orderId).then(response => {
        let order = this.getRespData(response)
        this.DHLReturn.setItem(order)
        this.loaded = true
      }).catch(error => this.createErrorLog(error))

    },
    methods: {

    },
  }
</script>

<style scoped>

</style>
